<template>
  <component :is="component" />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";
import { useUserStore } from "@/store/user";
import PageLoader from "@/components/v2/page-loader";

defineOptions({
  name: "about-us-page",
});

const userStore = useUserStore();
const isLoggedIn = computed(() => userStore.isLoggedIn);

const component = computed(() =>
  defineAsyncComponent({
    loader: () => (!isLoggedIn.value ? import("@/components/v2/about-us/index.vue") : import("@/components/about-us/index.vue")),
    loadingComponent: PageLoader,
    delay: 0,
  }),
);
</script>
